// shared/src/schemas/signal-drift-daily.ts
// Zod schema for `signal_drift_daily` table (0003:67-78).
// 9 columns. One row per (signal, scorer-fire-date) while in-flight.
// Written by daily-close-scorer (12.2.C); stops once signal_outcomes row exists
// for the (signal, horizon).
//
// Symmetric with macro_prediction_drift_daily for M-stage; replaces the v0
// sparse drift_at_50pct_horizon column on signal_outcomes (dropped in 0003).

import { z } from 'zod';

// 5 pacing classifications matching the DDL CHECK constraint at 0003:77.
export const SignalDriftPacingStatusEnum = z.enum([
  'on_pace',
  'ahead',
  'behind',
  'inverted',
  'resolved',
]);

export const SignalDriftDailySchema = z.object({
  id:                          z.string(),
  signal_id:                   z.string(),
  date:                        z.string(),                          // ISO date 'YYYY-MM-DD'
  days_elapsed:                z.number().int().nonnegative(),
  close_price:                 z.number().positive(),
  drift_from_signal_price_pct: z.number(),                          // direction-aware
  drift_to_conf_pct:           z.number().nullable(),               // NULL if conf_price IS NULL
  drift_to_inv_pct:            z.number().nullable(),               // NULL if inv_price IS NULL
  pacing_status:               SignalDriftPacingStatusEnum,
});

export type SignalDriftDaily = z.infer<typeof SignalDriftDailySchema>;
